<template>
  <QTable
    class="full-width"
    :columns="columns"
    :pagination="pagination"
    row-key="name"
    :rows="filteredStreamsUsers"
    :rows-per-page-options="rowPerPageOptions"
    style="height: 450px"
  >
    <template #top-row>
      <QTr class="filter-row">
        <QTd>
          <QInput
            v-model="filters.userId"
            borderless
            clearable
            debounce="300"
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filters['user.name']"
            borderless
            clearable
            debounce="300"
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd />
      </QTr>
    </template>

    <template #body="props">
      <QTr :props="props">
        <QTd
          key="userId"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.userId }}
        </QTd>
        <QTd
          key="name"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.user.name }}
        </QTd>
        <QTd
          key="accessLevel"
          class="wrap-table-content"
          :props="props"
        >
          {{ props.row.accessLevel }}
        </QTd>
      </QTr>
    </template>
  </QTable>
</template>

<script>
import { tableFilter } from "shared/helpers/object";

export default {
  name: "StreamsUsersTable",
  props: {
    streamsUsers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {
          name: "userId",
          align: "left",
          label: "ID",
          field: "userId",
          sortable: true,
          style: "width: 10%",
        },
        {
          name: "name",
          align: "left",
          label: "Name",
          field: "name",
          sortable: true,
          style: "width: 30%",
        },
        {
          name: "accessLevel",
          align: "center",
          label: "Access Level",
          field: "accessLevel",
          sortable: true,
          style: "width: 10%",
        },
      ],
      pagination: {
        rowsPerPage: 100,
      },
      rowPerPageOptions: [25, 50, 100, 250, 500],
      filters: {
        userId: "",
        "user.name": "",
      },
    };
  },
  computed: {
    filteredStreamsUsers() {
      return this.streamsUsers.filter((streamUser) =>
        tableFilter(streamUser, this.filters)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  .wrap-table-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    word-wrap: break-word;
    overflow-wrap: break-word;
    font-size: 14px;
  }
}
</style>
